import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

const PemeAppointmentCancel = ({ isOpen, onRequestClose, appointment }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const cancelAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      await axios.post("/api/peme-appointment/cancel", {
        id: `${appointmentId}`,
        appointmentstatus: "APPOINTMENT CANCELLED",
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("PEME Appointment cancelled successfully.");
      onRequestClose();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.response?.data || error.message || "An error occurred.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">cancel</i>
          Cancel PEME Appointment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}

        <div className="mb-4 p-3 rounded-3 d-flex align-items-start gap-3" style={{ background: "rgba(220,53,69,0.06)", border: "1px solid rgba(220,53,69,0.2)" }}>
          <i className="material-icons text-danger mt-1" style={{ fontSize: "1.4rem" }}>medical_services</i>
          <div>
            <p className="fw-semibold mb-1">Cancel this PEME Appointment?</p>
            <p className="text-muted small mb-0">
              This will permanently cancel the Pre-Employment Medical Examination appointment. This action cannot be undone.
            </p>
          </div>
        </div>

        {appointment?.pemeDetails?.fullName && (
          <div className="mb-4 p-3 rounded-3 bg-light border">
            <span className="text-muted small d-block">Candidate:</span>
            <span className="fw-bold" style={{ color: "#2f3a88" }}>{appointment.pemeDetails.fullName}</span>
          </div>
        )}

        <div className="d-flex justify-content-end gap-2">
          <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
            Keep Appointment
          </Button>
          <button
            className="btn btn-danger rounded-pill px-4 d-flex align-items-center gap-1"
            onClick={() => cancelAppointment(appointment.id)}
            disabled={loading}
          >
            <i className="material-icons" style={{ fontSize: "1rem" }}>cancel</i>
            Confirm Cancellation
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PemeAppointmentCancel;
